import React from 'react';
import './CloseBtn.scss';

export default function CloseBtn({ closeState }){

    const closeFunction = () => {
        closeState(false);
    }

  return (
    <>
      <img onClick={closeFunction} className='close-crusade' src="/static/close_btn.svg" />
    </>
  );
};
